import axios from '@/lib/axios';
import { RegistrationParams } from '../types';

const confirmRegistration = (data: RegistrationParams) => {
  return axios.post('/customer/flat_rates/registration/confirm', data);
}

export default confirmRegistration;